<template lang="pug">
.menu(:class="{'nav-open': $sidebar.showSidebar}")
  side-bar
    img.brand(v-on:click="getStatus"  alt="logo" style="cursor:pointer;width: 80px;position: relative;top: 24px; left: 10px;" src="img/logo-orange.png")
    span.brand Asia Alternatives
    template(slot-scope='props', slot='links')
      sidebar-item(:link="{name: 'Home', icon: 'fas fa-home', path: '/'}")
      sidebar-item(:link="{name: 'Paginated Reports', icon: 'fas fa-chart-pie', color: 'blue', path: '/paginated'}")
  .main-panel
    router-view(name='header')
    div(:class='{content: !$route.meta.hideContent}', @click='toggleSidebar')
      zoom-center-transition(:duration='200', mode='out-in')
        // your content here
        router-view
</template>
<script>
/* eslint-disable no-new */
import PerfectScrollbar from 'perfect-scrollbar';
import 'perfect-scrollbar/css/perfect-scrollbar.css';

function hasElement(className) {
  return document.getElementsByClassName(className).length > 0;
}

function initScrollbar(className) {
  if (hasElement(className)) {
    new PerfectScrollbar(`.${className}`);
  } else {
    // try to init it later in case this component is loaded async
    setTimeout(() => {
      initScrollbar(className);
    }, 100);
  }
}

/*import TopNavbar from './TopNavbar.vue';
import ContentFooter from './ContentFooter.vue';
import DashboardContent from './Content.vue';
import MobileMenu from './Extra/MobileMenu.vue';
import UserMenu from './Extra/UserMenu.vue';
*/
import { SlideYDownTransition, ZoomCenterTransition } from 'vue2-transitions';

export default {
  components: {
    SlideYDownTransition,
    ZoomCenterTransition
  },
  methods: {
    getStatus() {
    this.$eventBus.$emit('appEvents', {
                            exec: 'getStatus',
                            component: 'nav'
                        })
    },
    toggleSidebar() {
      if (this.$sidebar.showSidebar) {
        this.$sidebar.displaySidebar(false);
      }
    }
  },
  mounted() {
    let docClasses = document.body.classList;
    docClasses.add('sidebar-mini');
    docClasses.add('sidebar-menu');
    let isWindows = navigator.platform.startsWith('Win');
    if (isWindows) {
      // if we are on windows OS we activate the perfectScrollbar function
      initScrollbar('sidebar');
      initScrollbar('sidebar-wrapper');

      docClasses.add('perfect-scrollbar-on');
    } else {
      docClasses.add('perfect-scrollbar-off');
    }
  }
};
</script>
<style lang="scss">
$scaleSize: 0.95;
@keyframes zoomIn95 {
  from {
    opacity: 0;
    transform: scale3d($scaleSize, $scaleSize, $scaleSize);
  }
  to {
    opacity: 1;
  }
}
#app > #page > .menu {
position: absolute;
}

#app .off-canvas-sidebar .nav li:first-child>a, .sidebar .nav li:first-child>a {
    margin: 0 10px;
}

#app .off-canvas-sidebar .nav li>a, .sidebar .nav li>a {
    margin: 10px 10px 0;
	}

body.sidebar-mini .sidebar {
    width: 72px;
}
body.sidebar-menu #app .sidebar:hover span.brand {
    position: absolute;
            left: 64px;
            top: 24px;
            color: white;
            font-size: 1.33em;
            opacity: 1;
        font-weight: 700;
            }

body.sidebar-menu #app .menu span.brand {
    position: absolute;
        left: -100px;
                width: 200px;
                opacity: 0;
                transition: opacity 0.8s;
                }

#app .sidebar-wrapper .logo {
    width: 32px;
    top: 18px;
    left: 19px;
    position: relative;
}

.main-panel .zoomIn {
  animation-name: zoomIn95;
}
@keyframes zoomOut95 {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
    transform: scale3d($scaleSize, $scaleSize, $scaleSize);
  }
}
.main-panel .zoomOut {
  animation-name: zoomOut95;
}
#app #page .ps--active-x > .ps__rail-x {
display: none !important;
}
#app #page .fa-chart-pie {
color: #2ca8ff;
}
</style>
